import { render } from "./Mapbox.vue?vue&type=template&id=0adc4ae4&bindings={\"currentWaypoint\":\"data\"}"
import script from "./Mapbox.vue?vue&type=script&lang=js"
export * from "./Mapbox.vue?vue&type=script&lang=js"

import "./Mapbox.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script